exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".kye-table-v2__root .table_v2__expand-icon {\n  cursor: pointer;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n\n.kye-table-v2__root .is-expanded i {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/public/components/kye-table2/style/expanded.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAAqB;EAArB,4BAAqB;EAArB,qBAAqB,EAAE;;AAEzB;EACE,iCAAyB;UAAzB,yBAAyB,EAAE","file":"expanded.scss","sourcesContent":[".kye-table-v2__root .table_v2__expand-icon {\n  cursor: pointer;\n  display: inline-flex; }\n\n.kye-table-v2__root .is-expanded i {\n  transform: rotate(90deg); }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader??ref--10-2!./node_modules/postcss-loader/lib??ref--10-3!./node_modules/fast-sass-loader/lib??ref--10-4!./src/public/components/kye-table2/style/expanded.scss
// module id = o/mx
// module chunks = 7